import ninegrid from "../index.js";

export class ngRow
{
	#parent;
	#oldrow;
	#newrow;
	
	constructor(parent) {
		this.#parent = parent;
		this.#oldrow = -1;
		this.#newrow = -1;
		
		//this.onrowposchanged = new CustomEvent('rowposchanged', { bubbles: true, detail: {} });
		
		
	}
	
	get at() {
		return this.#newrow;
	};
	set at(v) {
		this.#oldrow = this.#newrow;
		this.#newrow = parseInt(v);

		/**
		 * Last Row & Hidden 일때 처리로직 추가해야함 
		 */

		if (!this.#parent.owner.body.querySelector(`tbody.bindable tr[data-row="${this.#newrow}"]`)) {
			setTimeout(() => {	/** combobox set row 오류 */
				this.#parent.owner.scrollTo_V1(this.#newrow);
			});
		}
		/**
		if (this.#oldrow != this.#newrow){
			this.onrowposchanged.oldrow		= this.#oldrow;
			this.onrowposchanged.row		= this.#newrow;
			
			this.onrowposchanged.olddata	= this.#parent.rawRecords[this.#oldrow];
			this.onrowposchanged.data		= this.#parent.rawRecords[this.#newrow];
			
			this.#parent.owner.dispatchEvent(this.onrowposchanged);
		} */
	}
	
	count = () => {
		return this.#parent.rawRecords.length;
	};
	
	has = (fn) => {
		return this.#parent.data.filter(fn).length > 0 ? true : false;
	}

	first = (fn) => {
		return (this.#parent.data.first(fn).__ng || {rowidx:-1}).rowidx;
	}
	
	last = (fn) => {
		return (this.#parent.data.last(fn).__ng || {rowidx:-1}).rowidx;
	}
}

export class ngData
{
	#owner;
	#parent;
	#records;
	#recordsNF;
	#nextId;
	#defaultHeight;
	
	constructor(owner, parent) {
		
		this.#owner = owner;
		this.#parent = parent;
		
		this.#records = [];
		this.#recordsNF = [];
		this.#nextId = 0;
		
		this.all = {
			get : (at, colnm) => {
				return this.#get(this.recordsNF(), at, colnm);
			},
			records : (at) => {
				return this.recordsNF(at);
			},
			count : () => {
				return this.recordsNF().length;
			},
			setRecord : (rowIndex, colIndex, value, updateRowState) => {
				return this.#setRecord(this.all.records(), rowIndex, colIndex, value, updateRowState);
			},
			indexOf : (row) => {
				return this.#indexOf(this.records(), row, this.recordsNF());
			},
			update : (row, at) => {
				return this.#update(this.records(), row, at);
			},
		}
		
		this.total = {
			indexOf : (row) => {
				return this.#indexOf(this.records(), row, this.#parent.rawRecords);
			},
		}
		
		this.initialize();
	}
	
	initialize = () => {
		
		this.#defaultHeight = [];
		$(this.#owner.template).each((i,el) => { this.#defaultHeight.push($(el).height()); });
		
		(this.#parent.rawRecords || []).forEach(v => {
			v.__ng.height	= this.#defaultHeight.slice();
		});
	};
	
	
	/**
	 * json 데이타를 그리드에 바인딩 합니다. 또는 바인딩된 데이타를 가져옵니다.
	 */
	get source() {
		return this.conv2(this.#parent.rawRecords);
		//return this.#parent.rawRecords;
	}
	set source(v) {
		this.clear();
		this.add(v, false);
	}
	
	set = (dataSource) => {
		this.clear();
		this.add(dataSource, false);
	};
	
	assign = (v) => {
		this.source = v;

		for (var i = 0; i < v.length; i++) {
			this.#records[i].__ng._[ninegrid.ROW.ID]	= v[i].__ng._[ninegrid.ROW.ID];
			//this.#records[i].__ninegrid.rowState		= v[i].__ng.rowState;
			
			this.#nextId = Math.max(this.#nextId, v[i].__ng.rowid);
		}
	};

	get nextId() {
		return ++this.#nextId;
	}

	getId = (o) => {
				
		return o.__ng._[ninegrid.ROW.ID];
	}

	get default() {

		return {
			//rowid	: this.nextId,//nextId + index,
			rowState: ninegrid.ROW_STATE.EMPTY,
			deleted	: false,
			filtered: false,
			pin		: false,
			expand	: true,
			visible	: true,
			paging	: true,
			height	: this.#defaultHeight.slice(),
			o		: {},		//origin value
			c		: {},		//checkable
			_		: [
				0,							// ID
				0,							// INDEX
				0,							// ORDER
				0,							// VISIBLE_ROW
				ninegrid.ROW_STATE.EMPTY,			// STATE
				false,						// FILTER
				false,						// PIN
				true,						// EXPAND
				false,						// COLLAPSE
				true,						// VISIBLE
				true,						// PAGING
				false,						// DELETED
				this.#defaultHeight.slice(),// HEIGHT
				-1,							// ORIGIN_ORDER
				{},							// ORIGIN
				{}							// EXPAND_CHECK
			],
		};
	}

	
	reset = () => {
		this.#records = [];
		this.#recordsNF = [];
		//this.#parent.rawRecords.filter(item => { return !item.__ng.deleted && !item.__ng.filtered && item.__ng.visible && item.__ng.paging; } );
	}
	

	refresh = () => {
		this.#parent.viewRecords.reset();
	}
	
	clearFilter = () => {
		this.#parent.rawRecords.map(item => { item.__ng.filtered = false; });
		this.#records = this.#parent.rawRecords.filter(item => { return !item.__ng.deleted && !item.__ng.filtered; } );
		return this.#records;
	}
	
	refreshFilter = () => {
		this.#records = this.#parent.rawRecords.filter(item => { return !item.__ng.deleted && !item.__ng.filtered; } );
		//this.#records.forEach((o,i) => { o.__ng.rowidx = i; });
		//this.getValidData().forEach((o,i) => { o.__ng._[ninegrid.ROW.ORDER] = i + 1; });
		this.#resetOrder();
		return this.#records;
	}
	
	/**
	 * { "key1": [1,2,...], "key2": [1,2,...], ... }
	 */
	setFilter = (oFilter) => {

		this.#owner.filtering.on();
	
	
		let jsonFilter = {};
		if (Array.isArray(oFilter)) {
			
			for (let key in oFilter[0]) {
				console.log(`::::::${key}::::::`)
				//key = key.trim();
				//console.log(key);
				jsonFilter[key] = Array.from(new Set(oFilter.map(item => item[key])));//oFilter.map(item => item[key]);
			}
		}
		else {
			jsonFilter = oFilter;
		}
		
		//jsonFilter.doc_id = [2, 18, 20, 28, 36, 45, 46, 48, 56, 64, 73, 81, 83, 90];

		//let filterData = [];
		
		
		this.clearFilter();
		
		for (let key in jsonFilter) {
			const arr = jsonFilter[key];
			const idx = this.#parent.owner.fields.indexOf(key);
			
			let isNum = false;
			for (let o of this.getValidData()) {
				if (o.v[idx] == null) continue;
				
				//console.log(o.v[idx], typeof o.v[idx])
				
				isNum = (typeof o.v[idx] === "number") ? true : false;
				
				break;
			}
			
			if (isNum) {
				for (var i = 0; i < arr.length; i++) {
					arr[i] = Number(arr[i]);
				}
			}
			
			/** filtering button 용 데이타 */
			/**
			filterData.push({
				"colnm" : key,
				"data" : arr,
			}); */
			//console.log(arr);
			
			
			//console.log(arr, idx, arr.nineBinarySearch(m.v[idx]));
		
			this.getValidData().filter(m => { return arr.nineBinarySearch(m.v[idx] || '') < 0; }).map(m => { m.__ng.filtered = true; });
			
			
			//break;
			
			
		}
		
		
		this.refreshFilter();
		
		this.#owner.shadowRoot.querySelectorAll("ng-filter-button").forEach(el => {
			el.filterOptions.forEach(opt => { opt.data = []; });
		});
		
		Object.entries(jsonFilter).forEach(([key, arr]) => {
			this.#owner.shadowRoot.querySelectorAll("ng-filter-button").forEach(el => {

				let options = el.filterOptions;

				options.forEach(opt => {
					if (opt.colnm === key) opt.data = arr;
				});

				el.filterOptions = options;
			});
		});
		
		
		this.#parent.owner.scrollTo_V1(0);
		
		this.#parent.owner.paging.reset();
	};
	
	
	/**
	 * 
	 */
	indexOf = (row) => {
		return this.#indexOf(this.recordsNF(), row, this.records());
	};
	#indexOf = (rec1, row, rec2) => {
		const rowData = rec1[row];

		return rec2.findIndex(m => { return m.__ng._[ninegrid.ROW.ID] == rowData.__ng._[ninegrid.ROW.ID]; });
	};
	
	moveRow = (row1, row2) => {
		
		if (row1 == row2) return;

		ninegrid.move(this.#parent.rawRecords, this.total.indexOf(row1), this.total.indexOf(row2));
		this.resetRecords();
		
		this.#parent.owner.dataManager.viewRecords.reset();
	};
	
	filter = (fn) => {
		return this.#records.filter(fn);
	}
	
	max = (colnm, fn) => {
		var arr = (fn ? this.filter(fn) : this.#parent.rawRecords).map(m => { return m[colnm]; });
		return (arr && arr.length > 0) ? arr.reduce( (a, b) => { return a > b ? a : b; }) : null;
	}
	
	min = (colnm, fn) => {
		var arr = (fn ? this.filter(fn) : this.#parent.rawRecords).map(m => { return m[colnm]; });
		return (arr && arr.length > 0) ? arr.reduce( (a, b) => { return a > b ? b : a; }) : null;
	}
	
	first = (fn) => {
		return this.filter(fn).first();
		//return this.filter(fn).first();
	}
	
	last = (fn) => {
		return this.filter(fn).last();
	}
	
	count = () => {
		return this.getValidData().length;
	};
	
	countNF = () => {
		return this.getValidDataNF().length;
	};
	
	onRowStateChanged = () => {
		const updateData = this.getChangedData();
		const td = $(`tbody td[data-bind=rowState]`, this.#parent.owner.body);
		if (td.length <= 0) return;
		const col = td.eq(0)[0].dataset.col;
		//var th = $(`thead th[data-col=${col}]`, this.#parent.owner.body).not(".col-indicator");
		const th = ninegrid.j.querySelectorAll(`thead th[data-col="${col}"]:not(.col-indicator)`, this.#parent.owner.body);

		th.removeClass("deleted").removeClass("added").removeClass("updated");
		if (updateData.delete.length > 0) th.addClass("deleted");
		else if (updateData.insert.length > 0) th.addClass("added");
		else if (updateData.update.length > 0) th.addClass("updated");
		
		this.#parent.owner.paging.refreshTotal();
	}
	
	#defaultInsert = (arr) => {
		if (!Array.isArray(arr)) arr = [arr];
		
		//var nextId = this.nextId();
		arr.forEach((o,i) => {
			o.__ng = this.default;
			o.__ng.rowid = this.nextId;
			o.__ng.rowState = ninegrid.ROW_STATE.INSERT;
			
			o.__ng._[ninegrid.ROW.ID] = o.__ng.rowid;
		});

		this.onRowStateChanged();
		
		return arr;
	}

	sort = (fn) => {
		this.#parent.rawRecords.sort(fn);
		this.#recordsNF.sort(fn);
		this.#records.sort(fn);
		//this.getValidData().forEach((o,i) => { o.__ng.rowidx = i; });
		//this.getValidData().forEach((o,i) => { o.__ng._[ninegrid.ROW.ORDER] = i + 1; });
		this.#resetOrder();
		this.#parent.owner.refresh();
	}
	
	#resetOrder = () => {
		//this.#recordsNF.forEach((o,i) => { o.__ng._[ninegrid.ROW.INDEX] = i; });
		//this.#recordsNF.filter(m => { return !m.__ng.deleted && !m.__ng.filtered && m.__ng.visible; } ).forEach((o,i) => { o.__ng._[ninegrid.ROW.ORDER] = i + 1; });

		this.#parent.rawRecords.forEach((o,i) => { o.__ng._[ninegrid.ROW.INDEX] = i; });
		this.#parent.rawRecords.filter(m => { return !m.__ng.deleted && !m.__ng.filtered && m.__ng.visible; } ).forEach((o,i) => { o.__ng._[ninegrid.ROW.ORDER] = i + 1; });
		
		const arr = this.#parent.rawRecords.filter(m => { return !m.__ng.deleted && m.__ng._[ninegrid.ROW.PIN]; } );
		arr.forEach((o,i) => { o.__ng._[ninegrid.ROW.VISIBLE_ROW] = (arr.length - i) * -1; });
		
		this.#records.forEach((o,i) => { o.__ng._[ninegrid.ROW.VISIBLE_ROW] = i; });
		//!m.__ng.deleted && !m.__ng.pin && !m.__ng._[ninegrid.ROW.PIN] && !m.__ng.filtered && m.__ng.visible && m.__ng.paging;
		
	};
	
	/**
	 * rowidx 갱신 대상
	 * 
	 * add, insert, delete (NF 포함)
	 * filtering
	 * sorting
	 * paging
	 * fixed
	 * row move
	 * 
	 * tree expand, collapse
	 * combo input -> filtering 된후
	 * 
	 * layout 변경시 rowidx 초기화?
	 */
	resetIndex = () => {
		/**
		 * rowidx 제거대상
		 */
		//this.#parent.rawRecords.map(m => { m.__ng._[ninegrid.ROW.ORDER] = m.__ng._[ninegrid.ROW.ORDER]; });
		this.#parent.rawRecords	.forEach((o,i) => { o.__ng.ii = i; o.__ng.rowidx = i; o.__ng.rowidx1 = i; });
		//this.getValidDataNF()	.forEach((o,i) => { o.__ng.ii = i; o.__ng.rowidx = i; o.__ng.rowidx1 = i; o.__ng._[ninegrid.ROW.INDEX] = i; });
		this.getValidData()	.forEach((o,i) => { o.__ng.i = i; o.__ng.rowidx = i; });
		
		this.#resetOrder();
	};

	/**
	 * add, insert, delete
	 * paging
	 */
	resetRecords = () => {
		
		this.#recordsNF	= this.#parent.rawRecords.filter(m => { return !m.__ng.deleted } );
		this.#records	= this.#parent.rawRecords.filter(m => { return !m.__ng.deleted && !m.__ng._[ninegrid.ROW.PIN] && !m.__ng._[ninegrid.ROW.COLLAPSE] && !m.__ng.filtered && m.__ng.visible && m.__ng.paging; } );
		//this.#records	= this.#parent.rawRecords.filter(m => { return !m.__ng.deleted && !m.__ng._[ninegrid.ROW.PIN] && !m.__ng._[ninegrid.ROW.COLLAPSE] && !m.__ng.filtered && m.__ng.visible; } );

		this.resetIndex();
	};
	
	#json2Array = (jsonArray) => {
		if (!Array.isArray(jsonArray)) jsonArray = [jsonArray];
		
		var arr = [];
		jsonArray.forEach(json => {
			var o = {
				v : [],
			};
			
			for (const colnm of this.#owner.fields.get()) {
				o.v.push(ninegrid.nvl(json[colnm], ""));		/** checklist: 숫자형식 체크해서 0으로 변경해야함 */
			}
			arr.push(o);
		});
		
		return arr;
	};
	
	

	exprFunction = (s) => {
				
		let args = '...args';
		let body = 'let [data, currow] = args; currow = Number(currow); return ' + s + ';';
		
		return new Function(args, body);
		//return new Function('data', 'currow', 'return ' + s + ';');
	};
	
	__ng = (row) => {
		var records = this.getValidData();

		if (records.length == 0) return null;
		
		try {
			return records[row].__ng;
		} catch (e) {
			console.error(e, records, row);
		}
		
	}
	
	

	getValidData = () => {
		//if (this.#records.length == 0) this.#records = this.#parent.rawRecords.filter(m => { return !m.__ng.deleted && !m.__ng.pin && !m.__ng.filtered && m.__ng.visible && m.__ng.paging; } );
		if (this.#records.length == 0) this.#records = this.#parent.rawRecords.filter(m => { return !m.__ng.deleted && !m.__ng._[ninegrid.ROW.PIN] && !m.__ng._[ninegrid.ROW.COLLAPSE] && m.__ng._[ninegrid.ROW.VISIBLE] && !m.__ng.filtered && m.__ng.visible && m.__ng.paging; } );
		return this.#records;
	}
	getValidDataNF = () => {
		
		if (this.#recordsNF.length == 0) this.#recordsNF = this.#parent.rawRecords.filter(m => { return !m.__ng.deleted; } );
		return this.#recordsNF;
		//return this.#parent.rawRecords.filter(item => { return !item.__ng.deleted; } );
	}
	
	
	
	conv = (arr) => {
		if (ninegrid.isNull(arr)) return arr;
		
		if (Array.isArray(arr)) {
			var r = [];
			for (const o of arr) {
				var t = {};
				for (var i = 0; i < this.#owner.fields.get().length; i++) {
					const colnm = this.#owner.fields.get()[i];
					t[colnm] = o.v[i]
				}
				t.__ng = o.__ng;
				r.push(t);
			}
			
			return r;
		}
		else {
			var o = arr;
			
			//if (ninegrid.isNull(o)) return null;
			var t = {};
			for (var i = 0; i < this.#owner.fields.get().length; i++) {
				const colnm = this.#owner.fields.get()[i];
				t[colnm] = o.v[i]
			}
			t.__ng = o.__ng;

			return t;
		}
	}
	conv2 = (arr) => {
		if (ninegrid.isNull(arr)) return arr;
		
		if (Array.isArray(arr)) {
			var r = [];
			for (const o of arr) {
				var t = {};
				for (var i = 0; i < this.#owner.fields.get().length; i++) {
					const colnm = this.#owner.fields.get()[i];
					t[colnm] = o.v[i]
				}
				
				t.__ng = o.__ng;
				
				r.push(t);
			}
			
			return r;
		}
		else {
			var o = arr;
			
			//if (ninegrid.isNull(o)) return null;
			var t = {};
			for (var i = 0; i < this.#owner.fields.get().length; i++) {
				const colnm = this.#owner.fields.get()[i];
				t[colnm] = o.v[i]
			}
			t.__ng = o.__ng;
			
			return t;
		}
	}
		
	
	

	

	/**
	 * 데이타의 row 상태를 변경한다.
	 * 
	 * state : 변경할 데이타의 상태, ninegrid.ROW_STATE.NORMAL, ninegrid.ROW_STATE.INSERT, ninegrid.ROW_STATE.UPDATE, ninegrid.ROW_STATE.DELETE, default: ninegrid.ROW_STATE.EMPTY
	 * fromIndex : 변경할 데이타의 시작 열 인덱스, Starting row index of the data to be changed, default : first row index
	 * toIndex : 변경할 데이타의 마지막 열 인덱스, Last row index of the data to be changed, default : last row index
	 * 
	 * changeRowState(state) : 전체 row 상태 변경
	 * changeRowState(state, fromIndex) : fromRow 번째 열 상태 변경
	 * changeRowState(state, fromIndex, toIndex) : fromIndex ~ toIndex 열 상태 변경
	 */
	changeRowState = (state, fromIndex, toIndex) => {
		const to = (v) => {
			if ([ninegrid.ROW_STATE.EMPTY, ninegrid.ROW_STATE.NORMAL].includes(state)) v.__ng.o = {};
			v.__ng.rowState = state;
		};
		
		if (!state) state = ninegrid.ROW_STATE.EMPTY;
		if (!fromIndex && !toIndex) { fromIndex = 0; toIndex = this.count() - 1; }
		if (!fromIndex) fromIndex = 0;
		if (!toIndex) toIndex = fromIndex;//this.count() - 1;
		if (toIndex >= this.count()) toIndex = this.count() - 1;
		
		this.#records.forEach			((o,i) => { if (o.__ng.rowidx >= fromIndex && o.__ng.rowidx <= toIndex) to(o); });
		this.#recordsNF.forEach		((o,i) => { if (o.__ng.rowidx >= fromIndex && o.__ng.rowidx <= toIndex) to(o); });
		this.getValidDataNF().forEach	((o,i) => { if (o.__ng.rowidx >= fromIndex && o.__ng.rowidx <= toIndex) to(o); });
		
		this.onRowStateChanged();
		
		this.#parent.viewRecords.reset();
	}
	
	/**
	 * checkable cell의 선택된 데이타를 조회한다.
	 * 
	 * colnm : 검색할 데이타의 컬럼명
	 */
	getCheckedData = (bind) => {
		return this.get().filter(m => { return m.__ng.c[bind] == true; });
	}
	/**
	 * 조건에 일치하는 데이타를 검색한다.
	 * 
	 * bind : 검색할 데이타의 컬럼명
	 * v : 검색할 데이타
	 */
	search = (bind, v) => {
		return this.get().filter(m => { return m[bind] == v; });
	}
	
	/**
	 * 데이타 변경시 사용자이벤트를 발생한다.
	 * 
	 * row : 변경된 행 인덱스
	 * bind : 변견된 컬럼명
	 * oldValue : 이전값
	 * newValue : 현재값
	 */
	#dataChanged = (row, bind, oldValue, newValue) => {
		if (oldValue == newValue) return;
		
		const customEvent		= new CustomEvent(ninegrid.EVENT.DATA_CHANGED, { bubbles: true, detail: {} });
		customEvent.row			= row;
		customEvent.bind		= bind;
		customEvent.oldvalue	= oldValue;
		customEvent.value		= newValue;
		customEvent.data		= this.get(row);

		this.#parent.owner.dispatchEvent(customEvent);
	}
	
	
	
	/**
	 * 그리드의 데이타를 초기화합니다.
	 */
	clear() {
		
		//delete this.#records;
		//delete this.#recordsNF;
		delete this.#parent.rawRecords;
		
		this.#records = [];
		this.#recordsNF = [];
		this.#parent.rawRecords = [];
		
		this.#parent.viewRecords.reset();
		//this.#parent.owner.view.redraw();
	}
	
	/**
	 * 그리드의 마지막 행에 데이타를 추가합니다.
	 * 
	 * dataSource : 그리드에 추가될 json 형식 데이타입니다. json Array 일 경우 배열의 길이만큼 데이타가 추가됩니다. null 일 경우는 빈 행이 추가됩니다.
	 * updateState : 행의 상태를 ninegrid.ROW_STATE.INSERT 로 변경할 지를 결정한다. 기본값은 "true" 입니다.
	 * 
	 * return : 데이타가 추가된 행 위치
	 */
	add = (dataSource, updateState) => {

		if (dataSource == undefined) dataSource = {};
		if (updateState == undefined) updateState = true;
		
		const arr = this.#json2Array(dataSource);

		this.#parent.rawRecords = this.#parent.rawRecords.concat(this.#defaultInsert(arr));
		
		const arr2 = this.#parent.rawRecords.map(m => { return m.__ng._[ninegrid.ROW.ORIGIN_ORDER]; });
		if (arr2.length > 0) {		
			const maxOrder = arr2.reduce( function (a, b) { 
				return a > b ? a : b;
			});

			this.#parent.rawRecords.forEach((o,i) => {
				if (o.__ng._[ninegrid.ROW.ORIGIN_ORDER] < 0) {
					o.__ng._[ninegrid.ROW.ORIGIN_ORDER] = maxOrder + 1 + i;
				}
			});
		}

		this.resetRecords();

		const row = this.count() - 1;
		if (!updateState) this.changeRowState(ninegrid.ROW_STATE.EMPTY, row - arr.length + 1, row);
		//this.#parent.owner.refresh();
		this.#parent.viewRecords.reset();

		return row;
	}
	
	
	/**
	 * 그리드의 지정된 행에 데이타를 삽입합니다.
	 * 
	 * dataSource : 그리드에 추가될 json 형식 데이타입니다. json Array 일 경우 배열의 길이만큼 데이타가 추가됩니다. null 일 경우는 빈 행이 추가됩니다.
	 * at : 데이타가 삽입될 위치
	 * updateState : 행의 상태를 ninegrid.ROW_STATE.INSERT 로 변경할 지를 결정한다. 기본값은 "true" 입니다.
	 * 
	 * return : 데이타가 삽입된 행 위치
	 */
	insert = (dataSource, at, updateState) => {
		
		if (dataSource == undefined) dataSource = {};
		if (at == undefined) at = 0;
		if (updateState == undefined) updateState = true;
		
		var arr = this.#json2Array(dataSource);
		
		/** 후방 원순서 증가 */
		const originOrder = this.#parent.rawRecords[at].__ng._[ninegrid.ROW.ORIGIN_ORDER];
		this.#parent.rawRecords.filter(m => {return m.__ng._[ninegrid.ROW.ORIGIN_ORDER] >= originOrder}).forEach(v => { v.__ng._[ninegrid.ROW.ORIGIN_ORDER] += arr.length; });
		/**
		this.#parent.rawRecords.forEach((o,i) => {
			if (i >= at) {
				o.__ng._[ninegrid.ROW.ORIGIN_ORDER] += arr.length;
			}
		}); */
		
		arr = this.#defaultInsert(arr);
		arr.forEach((o,i) => {
			o.__ng._[ninegrid.ROW.ORIGIN_ORDER] = originOrder + i;
		});
		
		this.#parent.rawRecords.splice(at, 0, ...arr);

	
		this.resetRecords();

		if (!updateState) this.changeRowState(ninegrid.ROW_STATE.EMPTY, at, at + arr.length - 1);
		
		//this.#parent.owner.refresh();
		this.#parent.viewRecords.reset();
		
		return at;
	}

	#defaultDelete = (arr) => {

		var changed = false;
		arr.sort((a,b) => {return b-a}).forEach(rowidx => {
			if (this.#records[rowidx].__ng.rowState == ninegrid.ROW_STATE.INSERT) {
				ninegrid.removeIf(this.#parent.rawRecords, item => { return item.__ng.rowid == this.#records[rowidx].__ng.rowid; } );
			}
			else {
				this.#parent.rawRecords.filter(item => { return item.__ng.rowid == this.#records[rowidx].__ng.rowid; } ).map(item => { item.__ng.deleted = true; item.__ng.rowState = ninegrid.ROW_STATE.DELETE; });
				changed = true;
			}
		});
		
		if (changed) this.onRowStateChanged();
		
		this.#records = this.#parent.rawRecords.filter(item => { return !item.__ng.deleted && !item.__ng.filtered; } );
		this.#recordsNF = this.#parent.rawRecords.filter(item => { return !item.__ng.deleted } );

		this.getValidDataNF().forEach((o,i) => { o.__ng.rowidx = i; });
		this.getValidData().forEach((o,i) => { o.__ng.rowidx = i; });

		//this.#parent.owner.refresh();
		this.#parent.viewRecords.reset();
	}

	/**
	 * 그리드의 데이타를 삭제합니다.
	 * 
	 * at : 삭제될 행의 위치, 배열인 경우 다수의 행이 삭제됩니다. undefined 인 경우 현재 행이 삭제됩니다.
	 * 
	 * return : 없음.
	 */
	delete = (at) => {
		var arr = [];
		if (Array.isArray(at)) {
			arr = at;
		}
		else if (typeof at === "undefined") {
			if (this.#parent.owner.row.at < 0) throw `invalid ${this.#parent.owner.row.at}`;
			arr = [this.#parent.owner.row.at];
		}
		else if (typeof at === "number" || typeof at === "string") {
			arr = [at];
		}
		/**else if (typeof at === "object") {
			arr = [at];
		}*/
		else if (typeof at === "object") {
			const index = this.#records.findIndex(m => { return m.__ng._[ninegrid.ROW.ID] == at.__ng._[ninegrid.ROW.ID]; });
			if (index < 0) throw new Error(`${at.__ng._[ninegrid.ROW.ID]} not found.`);
			arr = [index];
		}
		else {
			throw `invalid ${at}`;
		
		}
		this.#defaultDelete(arr);
	}
	
	/**
	 * not used
	 * 그리드의 데이타를 삭제합니다.
	 * 
	 * rowId : 삭제될 행의 ID.
	 * 
	 * return : 없음.
	 */
	deleteFromId = (rowId) => {
		
		var rec = this.records();
		const at = rec.findIndex(m => { return m.__ng._[ninegrid.ROW.ID] == rowId; });
		
		if (at < 0) throw new Error(`${rowId} not found.`);
		
		this.delete(at);
	}
	
	
	#update = (rec, o, at) => {
		
		if (typeof at === "undefined") {
			at = rec.findIndex(m => { return m.__ng._[ninegrid.ROW.ID] == o.__ng._[ninegrid.ROW.ID]; });
		}
		else if (typeof at === "number" || typeof at === "string") {
			at = parseInt(at);
		}
		/**else if (typeof at === "object") {
			arr = [at];
		}*/
		else {
			throw `invalid ${at}`;
		}
		//var row = o.__ng._[ninegrid.ROW.INDEX];
		var rowData = rec[at];
		var changed = false;
		
		for (const colnm in o) {
			
			if (["__ng","rowState"].includes(colnm)) continue;
			
			var COL_IDX = this.#owner.fields.indexOf(colnm);
			if (COL_IDX < 0) continue;

			var oldValue = rowData.v[COL_IDX];
			var newValue = o[colnm];
			
			rowData.v[COL_IDX] = newValue;

			if (oldValue != newValue){
				rowData.__ng.rowState = ninegrid.ROW_STATE.UPDATE;
				changed = true;
				
				this.#dataChanged(at, colnm, oldValue, newValue);
			}
		}
		
		if (changed) this.onRowStateChanged();

		//this.#parent.owner.refreshData(data.__ng._[ninegrid.ROW.VISIBLE_ROW]);
		this.#parent.owner.refreshData();
	}
	
	update = (o, at) => {
		this.#update(this.#records, o, at);
	}
	
	/**
	 * 특정 행의 컬럼값을 변경한다.
	 * 
	 * rowIndex : 변경할 데이타의 행 인덱스
	 * colnm : 변경할 데이타의 컬럼명
	 * value : 변경할 데이타 값
	 * updateState : 행의 상태를 ninegrid.ROW_STATE.INSERT 로 변경할 지를 결정한다. 기본값은 "true" 입니다.
	 */
	setValue = (rowIndex, colnm, value, updateRowState) => {
		this.#setValue(rowIndex, colnm, value, updateRowState, false);
	}
	setValueNF = (rowIndex, colnm, value, updateRowState) => {
		this.#setValue(rowIndex, colnm, value, updateRowState, true);
	}
	#setValue = (rowIndex, colnm, value, updateRowState, isPin) => {
		//this.#records[rowidx]
		
		/**
		const cell = $(`data-bind="${colnm}"`, this.#owner.template);
		if (cell.length > 0 && cell.dataset.type == "number") {
			value = Number(value);
		} */
		
		rowIndex = parseInt(rowIndex);
		if (updateRowState == undefined) updateRowState = true;
		
		const COL_IDX = this.#owner.fields.indexOf(colnm);
		if (COL_IDX < 0) return;
		
		var rowData = isPin ? this.getValidDataNF()[rowIndex] : this.getValidData()[rowIndex];
		//var rowData = records(index);
		var oldValue = rowData.v[COL_IDX];
		
		if (rowData.v[COL_IDX] != value && rowData.__ng.rowState != ninegrid.ROW_STATE.INSERT) {
			//if (!rowData.__ng.org) rowData.__ng.org = {};
			if (!rowData.__ng.o.hasOwnProperty(colnm)) rowData.__ng.o[colnm] = oldValue;

			if (updateRowState) {
				rowData.__ng.rowState = ninegrid.ROW_STATE.UPDATE;
				this.onRowStateChanged();		// thead row-state marking
			}
		}
		
		rowData.v[COL_IDX] = value;
		
		this.#parent.owner.refreshData(rowIndex);
		
		this.#dataChanged(rowIndex, colnm, oldValue, value);
	}
	
	/**
	 * 특정 행의 컬럼값을 변경한다.
	 * 
	 * rowIndex : 변경할 데이타의 행 인덱스
	 * colnm : 변경할 데이타의 컬럼명
	 * value : 변경할 데이타 값
	 * updateState : 행의 상태를 ninegrid.ROW_STATE.INSERT 로 변경할 지를 결정한다. 기본값은 "true" 입니다.
	 */
	setRecord = (rowIndex, colIndex, value, updateRowState) => {
		this.#setRecord(this.getValidData(), rowIndex, colIndex, value, updateRowState, false);
	}
	setRecordNF = (rowIndex, colIndex, value, updateRowState) => {
		this.#setRecord(this.getValidDataNF(), rowIndex, colIndex, value, updateRowState, true);
	}
	#setRecord = (rec, rowIndex, colIndex, value, updateRowState) => {

		rowIndex = parseInt(rowIndex);
		colIndex = parseInt(colIndex);
		if (updateRowState == undefined) updateRowState = true;
		
		
		var rowData = rec[rowIndex];
		//var rowData = records(index);
		var oldValue = rowData.v[colIndex];
		
		if (rowData.v[colIndex] != value && rowData.__ng.rowState != ninegrid.ROW_STATE.INSERT) {
			//if (!rowData.__ng.o.hasOwnProperty(colnm)) rowData.__ng.o[colnm] = oldValue;

			if (updateRowState) {
				rowData.__ng.rowState = ninegrid.ROW_STATE.UPDATE;
			}
		}
		
		rowData.v[colIndex] = value;
	}
	
	
	/**
	 * 변경된 데이타를 가져옵니다.
	 * 
	 * rowState : 행의 변경상태 (ninegrid.ROW_STATE.INSERT | ninegrid.ROW_STATE.UPDATE | ninegrid.ROW_STATE.DELETE)
	 * 
	 * return : JsonObject, 변경된 데이타
	 */
	getChangedData = (rowState) => {
		if (rowState) {
			return this.conv2( this.#parent.rawRecords.filter(m => { return m.__ng.rowState == rowState; } ) );
		}
		else {					
			return {
				insert: this.conv2( this.#parent.rawRecords.filter(m => { return m.__ng.rowState == ninegrid.ROW_STATE.INSERT; } ) ),
				update: this.conv2( this.#parent.rawRecords.filter(m => { return m.__ng.rowState == ninegrid.ROW_STATE.UPDATE; } ) ),
				delete: this.conv2( this.#parent.rawRecords.filter(m => { return m.__ng.rowState == ninegrid.ROW_STATE.DELETE; } ) ),
			};
		}
	};
	isChanged = () => {
		const arr = this.#parent.rawRecords.filter(m => { return m.__ng.rowState == ninegrid.ROW_STATE.INSERT || m.__ng.rowState == ninegrid.ROW_STATE.UPDATE || m.__ng.rowState == ninegrid.ROW_STATE.DELETE; } );
		return arr.length > 0;
	}
	
	
	/**
	 * 바인딩된 데이타를 Json 형식으로 가져옵니다.
	 * 
	 * at : 데이타 행 인덱스, 그리드 상에 보여지는 순서를 따릅니다.
	 * colnm : 조회할 데이타의 컬럼명
	 * 
	 * return : row 미지정시 모든 행의 데이타 값을 Json 배열로 반환
	 * 			row만 지정되었으면 해당 행의 Json 객체를 반환
	 * 			row & colnm이 지정되었으면 해당하는 데이타 값을 반환
	 */
	#get = (records, at, colnm) => {

		if (!records ||	 records.length <= 0) return;
		
		if (ninegrid.isNull(at)) {
			return this.conv2(records);
		}
		
		if (at < 0 || at >= records.length) {
			throw `invalid row : ${at}`;
		}
		
		if (colnm != null) {
			var idx = this.#owner.fields.indexOf(colnm);
			return (idx >= 0) ? records[at].v[idx] : null;
		}
		
		var v = at == null ? records : records[at];

		return this.conv(v);
	}

	get = (at, colnm) => {
		return this.#get(this.getValidData(), at, colnm);
	}
	getNF = (at, colnm) => {
		return this.#get(this.getValidDataNF(), at, colnm);
	}
	
	/**
	 * 바인딩된 데이타를 Array 형식으로 가져옵니다.
	 * 
	 * return : 모든 행의 데이타 값을 Array 배열로 반환
	 */
	records = (at) => {
		return (ninegrid.isNull(at)) ? this.getValidData() : this.getValidData(at);
	}
	recordsNF = (at) => {
		return (ninegrid.isNull(at)) ? this.getValidDataNF() : this.getValidDataNF(at);
	}

	/**
	 * 
	 */
	getRow = (at) => {
		return this.getValidData()[at];
	}
	getRowNF = (at) => {
		return this.getValidDataNF()[at];
	}
	
	/**
	 * 바인딩된 데이타를 Json 형식으로 가져옵니다.
	 * 
	 * colnm : 조회할 데이타의 컬럼명
	 * 
	 * return : 지정된 컬럼명에 해당하는 데이타 값을 배열로 반환
	 */
	#getMap = (records, colnm) => {
		var idx = this.#owner.fields.indexOf(colnm);
		if (idx < 0) return [];
		
		return records.map(m => { return m.v[idx] });
	}
	getMap = (colnm) => {
		return this.#getMap(this.getValidData(), colnm)
	}
	getMapNF = (colnm) => {
		return this.#getMap(this.getValidDataNF(), colnm)
	}
	
	findIndex = (fn) => {
		return this.#findIndex(this.getValidData(), fn);
	};
	findIndexNF = (fn) => {
		//28만 0.2sec
		return this.#findIndex(this.getValidDataNF(), fn);
	};
	#findIndex = function(arr, fn)
	{
		return this.conv2(arr).findIndex(fn);
		//return arrFilter.length > 0 ? arrFilter[0].__ng._[ninegrid.ROW.INDEX] : -1;
	};
	
	/**
	 * tree에서 호출
	 */
	findIndex_1 = (index) => {
		//28만 0.2sec
		return this.#indexOfRowIndex(this.getValidData(), index);
	};
	findIndexNF_1 = (index) => {
		//28만 0.2sec
		return this.#indexOfRowIndex(this.getValidDataNF(), index);
	};
	#indexOfRowIndex = function(arr, target)
	{
		let start = 0;
		let end = arr.length-1
		let mid
		
		while (start <= end) { //점점 좁혀지다가 start와 end의 순서가 어긋나게 되면 반복을 종료한다
		
			mid = parseInt((start+end)/2)
			
			if (target === arr[mid].__ng._[ninegrid.ROW.INDEX]) {
				return mid;
			}
			else{
				if (target < arr[mid].__ng._[ninegrid.ROW.INDEX]){
					end = mid - 1;
				}
				else {
					start = mid + 1;
				}
			}
		}
		
		return -1;
	};
}
